import * as Yup from "yup";
import Select from "react-select";
import { useFormik } from "formik";
import React, { useState } from "react";
import { curSym } from "../../utils/pip";
import { useDispatch, useSelector } from "react-redux";
import { Country, State } from "country-state-city";
import { message } from "antd";
import { placeOrder } from "../../redux/action/orderAction";
import NoRecord from "../../components/other/NoRecord";

const BillingDetailsForm = () => {
  const dispatch = useDispatch();
  const [paymentMethod, setPaymentMethod] = useState();
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [isNewAddress, setIsNewAddress] = useState(false);
  const { addressList } = useSelector((state) => state.authReducer);
  const { cartList } = useSelector((state) => state?.orderReducer);

  const [stateOptions, setStateOptions] = useState([]);
  const [selectedState, setSelectedState] = useState(null);
  const [shipToDifferentAddress, setShipToDifferentAddress] = useState(false);
  // Fetch the list of countries
  const countryOptions = Country.getAllCountries().map((country) => ({
    label: country.name,
    value: country.isoCode, // Use ISO code for state lookup
  }));

  const handleCountryChange = (country) => {
    setSelectedState(null);
    formik.setFieldValue("country", country);
    // Fetch states for the selected country using its ISO code
    const states = State.getStatesOfCountry(country.value).map((state) => ({
      label: state.name,
      value: state.isoCode,
    }));
    setStateOptions(states);
  };

  const handleStateChange = (state) => {
    setSelectedState(state);
    formik.setFieldValue("state", state);
  };

  const validationSchema = Yup.object({
    name: Yup.string().required("Please enter full name"),
    email: Yup.string()
    .trim()
    .email("Please enter a valid email")
    .required("Please enter email")
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?$/,
      "Please enter a valid email"
    ),
    number: Yup.string()
      .matches(/^[0-9]{10,15}$/, "Mobile number must be between 10 abd 15 digits")
      .required("Please enter a mobile number"),
    country: Yup.object().required("Please select a country"),
    state: Yup.object().required("Please select a state"),
    company_name: Yup.string(),
    address_line_1: Yup.string().required("Please enter address"),
    address_line_2: Yup.string().optional(),
    postal_code: Yup.string().required("Please enter postal/zip"),
    differentAddress: Yup.string().when("shipToDifferentAddress", {
      is: true,
      then: Yup.string().required("Shipping address is required"),
    }),
  });

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      number: "",
      country: "",
      state: "",
      company_name: "",
      address_line_1: "",
      address_line_2: "",
      apartment: "",
      postal_code: "",
      shipToDifferentAddress: false,
      differentAddress: "",
      other_notes: "",
    },
    validationSchema,
    onSubmit: (values) => {
      handlePlaceOrder(values);
      console.log("Form Data:", values);
    },
  });

  function calculateCartTotals() {
    let subtotal = 0;
    let totalDiscount = 0;

    cartList.forEach((item) => {
      const price = parseFloat(item?.product_details?.price);
      const discount = parseFloat(item?.product_details?.discount);
      const quantity = item?.quantity;

      subtotal += price * quantity;
      totalDiscount += discount * quantity;
    });

    const totalPrice = subtotal - totalDiscount;

    return {
      subtotal: subtotal?.toFixed(2),
      totalDiscount: totalDiscount?.toFixed(2),
      totalPrice: totalPrice?.toFixed(2),
    };
  }

  const handleSubmitOrder = (data) => {
    const callback = (response) => {
      if (response.success) {
        window.location.href = `${response.payment_link}`;
      }
    };
    dispatch(
      placeOrder({
        payload: data,
        callback,
      })
    );
  };

  const handlePlaceOrder = (values) => {
    if (!paymentMethod) {
      return message.error("Please select a payment method");
    }
    if (values == "previous address") {
      if (!selectedAddress) {
        return message.error("Please select a previous address");
      }
    }
    const newAddressObj = {
      ...values,
      total_order_price: calculateCartTotals()?.totalPrice,
      payment_method: paymentMethod,
      add_new_adddress: 1,
      country: values.country?.label,
      state: values.state?.label,
    };
    const prevAddress = {
      company_name: selectedAddress?.company_name,
      name: selectedAddress?.name,
      email: selectedAddress?.email,
      number: selectedAddress?.number,
      address_line_1: selectedAddress?.address_line_1,
      address_line_2: selectedAddress?.address_line_2,
      apartment: selectedAddress?.apartment,
      postal_code: selectedAddress?.postal_code,
      country: selectedAddress?.country,
      state: selectedAddress?.state,
      other_notes: selectedAddress?.other_notes,
      default_address_id: selectedAddress?.id,
      total_order_price: calculateCartTotals()?.totalPrice,
      payment_method: paymentMethod,
      add_new_adddress: 0,
    };
    const data = values == "previous address" ? prevAddress : newAddressObj;
    handleSubmitOrder(data);
  };

  return (
    <>
      <div class="untree_co-section pt-5">
        <div class="container">
          <div class="row">
            {isNewAddress && (
              <div class="col-md-6 mb-5 mb-md-0">
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
                  <h2 class="h3 mb-4 text-black">Billing Details</h2>
                  <div class="mb-3">
                    {addressList?.length > 0 && isNewAddress && (
                      <button
                        onClick={() => setIsNewAddress(false)}
                        class="ct_single_cart_btn ct_btn_animate text-white ct_black_animation_btn py-2 px-3"
                      >
                        {" "}
                        Select Address
                      </button>
                    )}
                  </div>
                </div>
                <div className="p-3 p-lg-5 border ct_bg_grey">
                  {/* Full Name */}
                  <div className="form-group row">
                    <div className="col-md-12 mb-3">
                      <label htmlFor="c_fname" className="text-black mb-1">
                        Full Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="c_fname"
                        name="name"
                        value={formik?.values?.name}
                        onChange={formik?.handleChange}
                        onBlur={formik?.handleBlur}
                        placeholder="Enter full name"
                      />
                      {formik?.touched?.name && formik?.errors?.name && (
                        <small className="text-danger">
                          {formik?.errors?.name}
                        </small>
                      )}
                    </div>
                  </div>

                  {/* Email Address */}
                  <div className="form-group row mb-4">
                    <div className="col-md-6">
                      <label htmlFor="c_email_address" className="text-black">
                        Email Address <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="c_email_address"
                        name="email"
                        value={formik?.values?.email}
                        onChange={formik?.handleChange}
                        onBlur={formik?.handleBlur}
                        placeholder="Enter email address"
                      />
                      {formik?.touched?.email && formik?.errors?.email && (
                        <small className="text-danger">
                          {formik?.errors?.email}
                        </small>
                      )}
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="c_phone" className="text-black">
                        Number <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="c_phone"
                        name="number"
                        value={formik?.values?.number}
                        onChange={formik?.handleChange}
                        onBlur={formik?.handleBlur}
                        placeholder="Phone Number"
                      />
                      {formik?.touched?.number && formik?.errors?.number && (
                        <small className="text-danger">
                          {formik?.errors?.number}
                        </small>
                      )}
                    </div>
                  </div>

                  {/* Country and State Selectors */}
                  <div className="form-group row">
                    <div className="col-md-6 form-group mb-3">
                      <label htmlFor="c_country" className="text-black mb-1">
                        Country <span className="text-danger">*</span>
                      </label>
                      <Select
                        className="ct_country_select"
                        options={countryOptions}
                        value={formik?.values?.country}
                        onChange={handleCountryChange}
                        onBlur={formik?.handleBlur}
                        placeholder="Select a country"
                      />
                      {formik?.touched?.country && formik?.errors?.country && (
                        <small className="text-danger">
                          {formik?.errors?.country}
                        </small>
                      )}
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="c_state_country" className="text-black mb-1">
                        State <span className="text-danger">*</span>
                      </label>
                      <Select
                        className="ct_country_select" style={{height:"50px"}}
                        options={stateOptions}
                        value={formik?.values?.state}
                        onChange={handleStateChange}
                        onBlur={formik?.handleBlur}
                        placeholder="Select a state"
                        isDisabled={!formik?.values?.country}
                      />
                      {formik?.touched?.state && formik?.errors?.state && (
                        <small className="text-danger">
                          {formik?.errors?.state}
                        </small>
                      )}
                    </div>
                  </div>

                  {/* Company Name */}
                  <div className="form-group row">
                    <div className="col-md-12 mb-3">
                      <label
                        htmlFor="c_company_name"
                        className="text-black mb-1"
                      >
                        Company Name{" "}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="c_company_name"
                        name="company_name"
                        value={formik?.values?.company_name}
                        onChange={formik?.handleChange}
                        placeholder="Enter company name"
                      />
                    </div>
                  </div>

                  {/* Address */}
                  <div className="form-group row">
                    <div className="col-md-12 mb-3">
                      <label
                        htmlFor="address_line_1"
                        className="text-black mb-1"
                      >
                        Address Line 1 <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="address_line_1"
                        name="address_line_1"
                        value={formik?.values?.address_line_1}
                        onChange={formik?.handleChange}
                        onBlur={formik?.handleBlur}
                        placeholder="Enter address"
                      />
                      {formik?.touched?.address_line_1 &&
                        formik?.errors?.address_line_1 && (
                          <small className="text-danger">
                            {formik?.errors?.address_line_1}
                          </small>
                        )}
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-md-12 mb-3">
                      <label
                        htmlFor="address_line_2"
                        className="text-black mb-1"
                      >
                        Address Line 2
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="address_line_2"
                        name="address_line_2"
                        value={formik?.values?.address_line_2}
                        onChange={formik?.handleChange}
                        onBlur={formik?.handleBlur}
                        placeholder="Enter address"
                      />
                      {formik?.touched?.address_line_2 &&
                        formik?.errors?.address_line_2 && (
                          <small className="text-danger">
                            {formik?.errors?.address_line_2}
                          </small>
                        )}
                    </div>
                  </div>

                  {/* Postal Zip */}
                  <div className="form-group row">
                    <div className="col-md-6 mb-3">
                      <label htmlFor="c_postal_zip" className="text-black">
                        Postal / Zip <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="c_postal_zip"
                        name="postal_code"
                        value={formik?.values?.postal_code}
                        onChange={formik?.handleChange}
                        onBlur={formik?.handleBlur}
                        placeholder="Enter postal / zip"
                      />
                      {formik?.touched?.postal_code &&
                        formik?.errors?.postal_code && (
                          <small className="text-danger">
                            {formik?.errors?.postal_code}
                          </small>
                        )}
                    </div>
                  </div>

                  {/* Ship to a different address */}
                  {/* <div className="form-group">
                    <label className="text-black">
                      <input
                        type="checkbox"
                        id="shipToDifferentAddress"
                        value={formik?.values?.shipToDifferentAddress}
                        onChange={formik?.handleChange}
                        onBlur={formik?.handleBlur}
                      />{" "}
                      Ship To A Different Address?
                    </label>
                    {formik?.values?.shipToDifferentAddress && (
                      <div
                        className="collapse show"
                        id="ship_different_address"
                      >
                        <div className="py-2">
                          <div className="form-group row mb-3">
                            <div className="col-md-12">
                              <label
                                // htmlFor="c_diff_address"
                                className="text-black"
                              >
                                Shipping Address{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="differentAddress"
                                // name="differentAddress"
                                value={formik?.values?.differentAddress}
                                onChange={formik?.handleChange}
                                onBlur={formik?.handleBlur}
                                placeholder="Enter shipping address"
                              />
                              {
                                (console.log(formik?.errors, "formik?.errors"),
                                // formik?.touched?.differentAddress &&
                                formik?.errors?.differentAddress && (
                                  <small className="text-danger">
                                    {formik?.errors?.differentAddress}
                                  </small>
                                ))
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div> */}

                  {/* Order Notes */}
                  <div className="form-group">
                    <label htmlFor="c_order_notes" className="text-black">
                      Order Notes
                    </label>
                    <textarea
                      className="form-control"
                      id="c_order_notes"
                      name="other_notes"
                      value={formik?.values?.other_notes}
                      onChange={formik?.handleChange}
                      placeholder="Enter any additional notes"
                    />
                  </div>
                </div>
              </div>
            )}
            {!isNewAddress && (
              <div class="col-md-6 mb-5 mb-md-0">
                <div class="mb-3">
                  <button
                    onClick={() => setIsNewAddress(true)}
                    class="ct_single_cart_btn ct_btn_animate text-white ct_black_animation_btn py-2 px-3"
                  >
                    {" "}
                    + Add New Address
                  </button>
                </div>
                {addressList?.length > 0 ? (
                  <div class="row ct_adress_checkout_scroll ">
                    <div class="col-lg-6 col-md-6 mb-3">
                      <div class="ct_old_address_card">
                        {addressList?.map((address) => {
                          return (
                            <div class="ct_oldaddress_dtl" key={address?.id}>
                              <input
                                class="ct_radio_input"
                                type="radio"
                                name="card"
                                checked={selectedAddress?.id === address?.id}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setSelectedAddress(address);
                                  }
                                }}
                              />
                              <div>
                                <p class="mb-0"></p>
                                <p class="mb-0">
                                  {" "}
                                  {address?.address_line_1},{" "}
                                  {address?.city || ""} {address?.state},{" "}
                                  {address?.country}
                                </p>
                                {address?.postal_code}
                                <p class="mb-0">
                                  <strong>Phone:</strong> {address?.number}
                                </p>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                ) : (
                  <NoRecord />
                )}
              </div>
            )}
            <div class="col-md-6">
              <div class="row mb-5">
                <div class="col-md-12">
                  <h2 class="h3 mb-4 text-black">Your Order</h2>
                  <div class="p-3 p-lg-5 border ct_bg_grey">
                    <table class="table site-block-order-table mb-5 ct_checkout_cart_main">
                      <thead>
                        <th>Product</th>
                        <th>Total</th>
                      </thead>
                      <tbody>
                        {cartList?.map((item, index) => {
                          return (
                            <tr>
                              <td>
                                {item?.product_details?.product_name}{" "}
                                <strong class="mx-2">x</strong> {item.quantity}
                              </td>
                              <td>
                                {curSym }{item?.quantity *
                                  parseFloat(item?.product_details.price)}
                              </td>
                            </tr>
                          );
                        })}
                        <tr>
                          <td class="text-black font-weight-bold">
                            <>Cart Subtotal</>
                          </td>
                          <td class="text-black">
                            {" "}
                            {curSym}
                            {calculateCartTotals()?.subtotal}
                          </td>
                        </tr>
                        <tr>
                          <td class="text-black font-weight-bold">
                            <strong>Total Discount</strong>
                          </td>
                          <td class="text-black font-weight-bold">
                            <strong>
                              {curSym}
                              {calculateCartTotals()?.totalDiscount}
                            </strong>
                          </td>
                        </tr>
                        <tr>
                          <td class="text-black font-weight-bold">
                            <strong>Order Total</strong>
                          </td>
                          <td class="text-black font-weight-bold">
                            <strong>
                              {" "}
                              {curSym}
                              {calculateCartTotals()?.totalPrice}
                            </strong>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <div>
                      <h6 class="text-dark  mb-3">Select Payment Method</h6>
                      <div class="border p-3 mb-3">
                        <label
                          class="h6 mb-0"
                          for="debit_card"
                          onclick="window.location='payment-debit-card.html'"
                        >
                          <a class="d-block">
                            <input
                              name="card"
                              type="radio"
                              class="me-1"
                              id="debit_card"
                              value={"Debit Card"}
                              onChange={(e) => setPaymentMethod(e.target.value)}
                            />
                            Debit Card
                          </a>
                        </label>
                      </div>

                      <div class="border p-3 mb-3">
                        <label
                          class="h6 mb-0"
                          onclick="window.location='payment-card.html'"
                          for="credit_card"
                        >
                          <a class="d-block">
                            <input
                              type="radio"
                              name="card"
                              id="credit_card"
                              value={"Credit Card"}
                              onChange={(e) => setPaymentMethod(e.target.value)}
                              class="me-1"
                            />
                            Credit Card
                          </a>
                        </label>
                      </div>
                    </div>
                    <div class="form-group">
                      <button
                        type="button"
                        class="btn btn-secondary ct_btn_animate w-100"
                        onClick={() => {
                          !isNewAddress
                            ? handlePlaceOrder("previous address")
                            : formik.handleSubmit();
                        }}
                      >
                        Place Order
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BillingDetailsForm;
